export default [{
  path: 'recoveryReport',
  name: 'recoveryReport',
  component: function component() {
    return import('@/views/recoveryManage/recoveryReport/index');
  }
}, {
  path: 'recoveryAmountReport',
  name: 'recoveryAmountReport',
  component: function component() {
    return import('@/views/recoveryManage/recoveryReport/amount/index');
  }
}, {
  path: 'recoveryOfflineRecord',
  name: 'recoveryOfflineRecord',
  component: function component() {
    return import('@/views/recoveryManage/recoveryOfflineRecord/index');
  }
}, {
  path: 'recoveryOfflineRecordAdd',
  name: 'recoveryOfflineRecordAdd',
  component: function component() {
    return import('@/views/recoveryManage/recoveryOfflineRecord/add');
  }
}, {
  path: 'recoveryCustomReport',
  name: 'recoveryCustomReport',
  component: function component() {
    return import('@/views/recoveryManage/recoveryCustomReport/index');
  }
}];